<div
  *ngIf="loader.loading()"
  class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
>
  <div class="flex flex-col items-center gap-3">
    <div class="relative w-8 h-8">
      <div
        class="absolute inset-0 border-4 border-sky-400 border-t-transparent rounded-full animate-spin-fast"
      ></div>
      <div
        class="absolute inset-2 border-4 border-pink-500 border-t-transparent rounded-full animate-spin"
      ></div>
    </div>
    <p class="text-white text-sm font-medium animate-pulse">Loading...</p>
  </div>
</div>